/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobArchivedQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobArchivedQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobArchivedQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobArchivedQueryOperator>): TemplateJobArchivedQueryOperator {
        let obj = Object.assign(new TemplateJobArchivedQueryOperator(), model);
        TemplateJobArchivedQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobArchivedQueryOperator>): TemplateJobArchivedQueryOperator {
        if (!model) return null;
        return TemplateJobArchivedQueryOperator.newInstance(<TemplateJobArchivedQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobArchivedQueryOperator) {
        if (!obj) return;

        models.TemplateJobArchivedQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobArchivedQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobArchivedQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Set to true to include archived jobs. Defaults to false.
     */
    archived: boolean;

}
